import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';
import ProductItemThumbnail
  from 'components/dashboard/catalog-content/ProductItemThumbnail';
import ProductItemName from 'components/dashboard/catalog-content/ProductItemName';
import ProductItemPrice from 'components/dashboard/catalog-content/ProductItemPrice';
import ProductItemUrl from 'components/dashboard/catalog-content/ProductItemUrl';
import ProductPublishedCheckbox
  from 'components/dashboard/catalog-content/ProductPublishedCheckbox';
import ShowProductPriceCheckbox
  from 'components/dashboard/catalog-content/ShowProductPriceCheckbox';
import ProductDeleteIcon from 'components/dashboard/catalog-content/ProductDeleteIcon';

import './CatalogProductItemMobile.css';

const CatalogProductItemMobile = ({ item, patchProductLinkSuccess }) => {
  const [showActions, setShowActions] = useState(false);

  return (
    <div className="catalog-product-item-mobile__component">
      <div
        className={`product-item-wrapper
        ${(patchProductLinkSuccess && patchProductLinkSuccess.id === item.id) ?
          ' pulse' : ''}`}
      >
        <div className="main-block">
          <div className="swap-icon-container">
            <CommonSwapIcon />
          </div>
          <div className="info-container">
            <div className="name-published">
              <ProductItemName
                productId={item.id}
                name={item.name}
              />
            </div>

            {showActions &&
              <Fragment>
                <div className="product-url">
                  <ProductItemUrl
                    url={item.url}
                    productId={item.id}
                  />
                </div>

                <div className="thumbnail-price">
                  <ProductItemThumbnail
                    productId={item.id}
                    thumbnail={item.thumbnail}
                  />
                  <ProductItemPrice
                    productId={item.id}
                    initialPrice={item.price}
                    initialCurrency={item.currency}
                  />
                </div>

                <div className="show-price">
                  <ShowProductPriceCheckbox
                    productId={item.id}
                    showPrice={item.show_price}
                  />
                </div>

                <div className="actions-block-mobile">
                  <ProductPublishedCheckbox
                    productId={item.id}
                    isPublished={item.is_published}
                  />

                  <div className="delete-icon-mobile">
                    <ProductDeleteIcon productId={item.id} />
                  </div>
                </div>
              </Fragment>
            }
          </div>
        </div>

        <div
          className="arrow-block"
          onClick={() => setShowActions(!showActions)}
          role="button"
          tabIndex={-1}
        >
          <div className={`arrow-icon${showActions ? ' up' : ' down'}`} />
        </div>
      </div>
    </div>
  );
};

CatalogProductItemMobile.propTypes = {
  item: PropTypes.object.isRequired,
  patchProductLinkSuccess: PropTypes.object,
};

CatalogProductItemMobile.defaultProps = {
  patchProductLinkSuccess: null,
};

export default CatalogProductItemMobile;
